import { Text as e } from "../Typography/Typography.js";
import "../Typography/index.js";
import t from "./Notification.module.js";
import { c as n } from "react/compiler-runtime";
import { Button as r } from "@jetbrains/ring-ui-built/components/button/button";
import i from "classnames";
import { Fragment as a, createElement as o, useState as s } from "react";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
import u from "@jetbrains/icons/chevron-20px-down";
import d from "@jetbrains/icons/close";
//#region src/components/Notification/Notification.tsx
var f = (a) => {
	let o = n(47), f, h, g, _, v, y, b, x, S, C;
	o[0] === a ? (f = o[1], h = o[2], g = o[3], _ = o[4], v = o[5], y = o[6], b = o[7], x = o[8], S = o[9], C = o[10]) : ({className: g, children: h, type: C, title: S, onClose: _, actions: f, collapsible: b, onCollapseChange: v, isCollapsed: x, ...y} = a, o[0] = a, o[1] = f, o[2] = h, o[3] = g, o[4] = _, o[5] = v, o[6] = y, o[7] = b, o[8] = x, o[9] = S, o[10] = C);
	let w = b !== void 0 && b, [T, E] = s(x !== void 0 && x), D;
	o[11] !== T || o[12] !== v ? (D = () => {
		v && v(!T), E(p);
	}, o[11] = T, o[12] = v, o[13] = D) : D = o[13];
	let O = D, k = t[C], A = !h, j;
	o[14] !== g || o[15] !== k || o[16] !== A ? (j = i(t.wrapper, g, k, { [t.inline]: A }), o[14] = g, o[15] = k, o[16] = A, o[17] = j) : j = o[17];
	let M;
	o[18] !== T || o[19] !== S ? (M = S && /* @__PURE__ */ c("header", {
		className: i(t.header, { [t.isCollapsed]: T }),
		children: S
	}), o[18] = T, o[19] = S, o[20] = M) : M = o[20];
	let N;
	o[21] !== w || o[22] !== _ || o[23] !== a ? (N = _ && !w && /* @__PURE__ */ c(r, {
		"aria-label": "Close",
		onClick: _,
		icon: d,
		"data-test": `${a["data-test"] ?? "notification"}-close-button`
	}), o[21] = w, o[22] = _, o[23] = a, o[24] = N) : N = o[24];
	let P;
	o[25] !== M || o[26] !== N ? (P = /* @__PURE__ */ l("div", {
		className: t.titleContainer,
		children: [M, N]
	}), o[25] = M, o[26] = N, o[27] = P) : P = o[27];
	let F;
	o[28] !== h || o[29] !== T ? (F = !T && /* @__PURE__ */ c("div", { children: h }), o[28] = h, o[29] = T, o[30] = F) : F = o[30];
	let I;
	o[31] !== w || o[32] !== O || o[33] !== T || o[34] !== a ? (I = w && /* @__PURE__ */ c(r, {
		"aria-label": T ? "Expand" : "Collapse",
		className: i({ [t.isCollapsed]: T }),
		onClick: O,
		icon: u,
		iconClassName: t.chevronIcon,
		"data-test": `${a["data-test"] ?? "notification"}-collapse-button`
	}), o[31] = w, o[32] = O, o[33] = T, o[34] = a, o[35] = I) : I = o[35];
	let L;
	o[36] !== I || o[37] !== P || o[38] !== F ? (L = /* @__PURE__ */ l(e, {
		as: "div",
		className: t.container,
		children: [
			P,
			F,
			I
		]
	}), o[36] = I, o[37] = P, o[38] = F, o[39] = L) : L = o[39];
	let R;
	o[40] === f ? R = o[41] : (R = f && /* @__PURE__ */ c("div", {
		className: t.actions,
		children: f.map(m)
	}), o[40] = f, o[41] = R);
	let z;
	return o[42] !== y || o[43] !== L || o[44] !== R || o[45] !== j ? (z = /* @__PURE__ */ l("div", {
		className: j,
		...y,
		children: [L, R]
	}), o[42] = y, o[43] = L, o[44] = R, o[45] = j, o[46] = z) : z = o[46], z;
};
function p(e) {
	return !e;
}
function m(e) {
	if ("custom" in e) return /* @__PURE__ */ c(a, { children: e.custom }, e.key);
	let { children: t, key: n, ...i } = e;
	return /* @__PURE__ */ o(r, {
		...i,
		key: n,
		"data-test": n
	}, t);
}
//#endregion
export { f as Notification };
